import classNames from "classnames";
import React, { useState } from "react";
import { RicosAlignmentContextProvider, RicosNodeContextProvider } from "./../../ricos-context";
import { ROOT } from "../data-hooks";
import collapsibleListStyles from "../statics/styles/collapsible-list-component.rtlignore-scss";
import { getAlignmentFromDirection } from "../utils";
import { CollapsibleListContextProvider } from "./collapsibleListContext";
const CollapsibleList = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  const [expandedItemId, setExpandedItemId] = useState(void 0);
  const styles = collapsibleListStyles;
  const direction = node.collapsibleListData?.direction?.toLowerCase() || "ltr";
  const alignment = getAlignmentFromDirection(direction);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement("div", { className: classNames(styles[direction], styles.listDimensions), "data-hook": ROOT }, /* @__PURE__ */ React.createElement(RicosAlignmentContextProvider, { textAlignment: alignment }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(
    CollapsibleListContextProvider,
    {
      expandedItemId,
      setExpandedItemId
    },
    /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [] })
  )))));
};
const CollapsibleListRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleList, { key: node.id, node, ...props });
};
var collapsibleList_default = CollapsibleListRenderer;
export {
  collapsibleList_default as default
};
//# sourceMappingURL=collapsibleList.js.map

import "@wix/ricos/css/plugin-collapsible-list-viewer.global.css";